module.exports = __webpack_public_path__ + "static/media/circle_of_excellence_CP-2020-small.8f7364f5.png";